import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { QuestionnaireService } from '../services/questionnaire.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidateId } from "../id-validator";
import { IncomesArrayComponent } from '../incomes-array/incomes-array.component';
import { Draft } from '../services/draft.service';
import { SystemTablesService } from '../services/system-tables.service';
import { SysTableObj } from '../models/sysTableObj.model';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { FinancingSourcesPopupComponent } from '../financing-sources-popup/financing-sources-popup.component';

@Component({
	selector: 'app-financing-sources',
	templateUrl: './financing-sources.component.html',
	styleUrls: ['./financing-sources.component.scss']
})
export class FinancingSourcesComponent implements OnInit, AfterViewChecked {
	private route$: Subscription;
	prevQID: any;
	qID;
	sourceCapital = [{ 'source': '', 'amount': '', readOnly: false }];
	sourceSelect: string[];
	visibleQids;
	editQuestion;
	currentStep;
	submitQID;
	financingSources: FormGroup;
	submitted;
	warnInfo = false;
	isEdit;
	qFields = {
		1: [{ name: "incomes", type: "OtherIncome" ,systemTable:"arrayTable",
		qNamesSystemTable: [[["type"],["type"]]],
		numberSystemTable: [[["2093"],["2093"]]]}],
		5: [{ name: "mortgageMonthlyRefund", validators: [Validators.required] }]
	};
	qArrFields = {
		1: [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required, Validators.min(1)] },
			{ name: "source", validators: [Validators.min(1)] }
		]
	};
	financingSourcesObjects: SysTableObj[];

	constructor(
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		private draft: Draft,
		private fb: FormBuilder,
		private modalService: NgbModal,
		private sysTablesService: SystemTablesService,
		private translate: TranslateService,
		private _changeDetector: ChangeDetectorRef
	) { }

	ngOnInit() {
		this.financingSourcesObjects = this.sysTablesService.getTable('2093');
		this.sourceSelect = this.financingSourcesObjects.map(v => v.name);

		this.createForm();

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;

			if (params.qid === "all") {
				this.isEdit = true;
				//let answeredQuestions = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				//this.visibleQids = "all";
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				//let answeredQuestions = this.questionnaireService.getAnsweredQuestions(this.currentStep);



				//console.log("++++  ++++  ++++  ++++>>>  UserDetailsComponent",answeredQuestions);
			} else {
				this.isEdit = false;
				this.setValidators();
				//this.visibleQids = null;
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				this.setFocusFirstComponent(this.qID);
			}
		});
		if (this.draft.autoForm) {
			this.financingSources = this.draft.buildForm(this.currentStep, this.financingSources);
		}
	}

	private setFocusFirstComponent(qID) {
		// if (qID === '5') {
		// 	this.focusToElement(`input[aria-label="${this.translate.instant('LIABILITIES.QUESTION1.REQUIRED1')}"]`);
		// }
	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("financing-sources");
		this.financingSources = this.fb.group({
			incomes: IncomesArrayComponent.buildIncomes(this.questionnaireService.getQuestion(this.currentStep, "1").answer.fieldsArray),
			mortgageMonthlyRefund: this.questionnaireService.getQuestion(this.currentStep, "5").answer.fields[0].answerValue
		});
	}

	setValidators() {
		this.questionnaireService.clearAllQuestionValidators(this.financingSources.controls, this.qFields, this.qArrFields);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.financingSources.controls, this.qFields, "6", this.qID === "1" ? this.qArrFields : null, false);


		this.submitted = false;
	}

	amountValidator() {
		return (control: AbstractControl): { [key: string]: any } => {
			this.warnInfo = false;

			//------------------------------------------kitsourim

			//kitsour le getQuestion function
			let getQuestion = this.questionnaireService.getQuestion;
			//kitsour le stepim
			let step5 = this.questionnaireService.getStepByID("5");
			let step4 = this.questionnaireService.getStepByID("4");
			//kitsour le maarah chel itravouyot nossafot
			let liabilityStep5Question5 = getQuestion(step5, "5").answer.fieldsArray;
			//kitsour le maarah chel ahnassot nossafot
			let incomeStep4Question20 = getQuestion(step4, "20").answer.fieldsArray;

			//------------------------------------------lover rashi itrayvouyot

			//shoum ehzer hotchi al anehess
			let liabilityStep5Question2 = (+(getQuestion(step5, "2").answer.fields[0].answerValue)) ? (+(getQuestion(step5, "2").answer.fields[0].answerValue)) : 0;
			//shoum ehzer al amashkenta
			let liabilityStep6Question5 = +control.value;
			//itrayvouyot nossafot
			let liabilityStep5Question7 = 0;
			for (let index = 0; index < liabilityStep5Question5.length; index++) {
				if (liabilityStep5Question5[index][3].answerValue === "1") {
					liabilityStep5Question7 += (+liabilityStep5Question5[index][2].answerValue);
				}
			}

			//------------------------------------------lover rashi ahnassot

			//sahir ahnassot hodchit
			let incomeStep4Question10 = (+(getQuestion(step4, "10").answer.fields[0].answerValue)) ? (+(getQuestion(step4, "10").answer.fields[0].answerValue)) : 0;
			//atsmai ahnassot chenatit
			let incomeStep4Question13 = (+(getQuestion(step4, "13").answer.fields[0].answerValue)) ? (+(getQuestion(step4, "13").answer.fields[0].answerValue)) / 12 : 0;
			//sahir&atsmai ahnassot hodchit ke sahir
			let incomeStep4Question15 = (+(getQuestion(step4, "14").answer.fields[1].answerValue)) ? (+(getQuestion(step4, "14").answer.fields[1].answerValue)) : 0;
			//sahir&atsmai ahnassot chenatit ke atsmai
			let incomeStep4Question19 = (+(getQuestion(step4, "18").answer.fields[1].answerValue)) ? (+(getQuestion(step4, "18").answer.fields[1].answerValue)) / 12 : 0;
			//ahnassot nossafot
			let incomeStep4Question21 = 0;
			for (let index = 0; index < incomeStep4Question20.length; index++) {
				incomeStep4Question21 += (+incomeStep4Question20[index][1].answerValue);
			}

			//------------------------------------------lovim nossafim

			//sahir ahnassot hodchit
			let incomeStep4Question38ForOtherBorrowers = 0;
			//atsmai ahnassot chenatit
			let incomeStep4Question41ForOtherBorrowers = 0;
			//sahir&atsmai ahnassot hodchit ke sahir
			let incomeStep4Question43ForOtherBorrowers = 0;
			//sahir&atsmai ahnassot chenatit ke atsmai
			let incomeStep4Question47ForOtherBorrowers = 0;
			//ahnassot nossafot
			let incomeStep4Question49ForOtherBorrowers = 0;

			for (let index = 0; index < this.questionnaireService.getBorrowers().length; index++) {
				incomeStep4Question38ForOtherBorrowers += (+(getQuestion(step4, "38-" + (index + 1)).answer.fields[0].answerValue)) ? (+(getQuestion(step4, "38-" + (index + 1)).answer.fields[0].answerValue)) : 0;
				incomeStep4Question41ForOtherBorrowers += (+(getQuestion(step4, "41-" + (index + 1)).answer.fields[0].answerValue)) ? (+(getQuestion(step4, "41-" + (index + 1)).answer.fields[0].answerValue)) / 12 : 0;
				incomeStep4Question43ForOtherBorrowers += (+(getQuestion(step4, "42-" + (index + 1)).answer.fields[1].answerValue)) ? (+(getQuestion(step4, "42-" + (index + 1)).answer.fields[1].answerValue)) : 0;
				incomeStep4Question47ForOtherBorrowers += (+(getQuestion(step4, "46-" + (index + 1)).answer.fields[1].answerValue)) ? (+(getQuestion(step4, "46-" + (index + 1)).answer.fields[1].answerValue)) / 12 : 0;
				//console.log("q48\t" + (+(getQuestion(step4,"48-"+(index+1)).answer.fields[0].answerValue)) ? (+(getQuestion(step4,"48-"+(index+1)).answer.fields[0].answerValue)) : 0);
				let tmp = getQuestion(step4, "48-" + (index + 1)).answer.fieldsArray;
				for (let index = 0; index < tmp.length; index++) {
					incomeStep4Question49ForOtherBorrowers += (+tmp[index][1].answerValue);
				}
			}

			let totalLiabilities = liabilityStep5Question2 + liabilityStep5Question7 + liabilityStep6Question5;
			let totalIncomes = incomeStep4Question10 + incomeStep4Question13 + incomeStep4Question15 + incomeStep4Question19 + incomeStep4Question21 + incomeStep4Question38ForOtherBorrowers + incomeStep4Question41ForOtherBorrowers + incomeStep4Question43ForOtherBorrowers + incomeStep4Question47ForOtherBorrowers + incomeStep4Question49ForOtherBorrowers;
			let result = totalLiabilities / totalIncomes;

			if (result >= 0.5) {
				return { amountValidator: true };
			} else if (result > 0.4 && result < 0.5) {
				this.warnInfo = true;
				return null;
			}
			return null;
		}
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
			this.questionnaireService.isActiveEditQuestion = false;
		}
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit", value);
		this.submitted = true;
		if (!valid) {
			this.questionnaireService.submitForm(true);
		}
		else {
			this.questionnaireService.submitForm(false);
		}
		if (this.qID === 'all' || this.qID === '1') {
			const s = this.financingSources.controls.incomes as FormArray;
			if (s.controls[0].get('type').value === 'אחר' && s.controls[0].get('source').value === "") {
				this.questionnaireService.showErrorMsg(true);
				valid = false;
			}
		}
		if (valid) {
			let q;
			this.submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[this.submitQID];

			let values = q.map(r => value[r.name]);

			let valueTmp = JSON.parse(JSON.stringify(value));
			this.setFinnancingCode(valueTmp);
			if(this.submitQID==="1"){
				let tmpSum1 = (Number)(this.questionnaireService.getQuestion(this.questionnaireService.getStepByID("3"), "2").answer.fields[0].answerValue) -
				(Number)(this.questionnaireService.getQuestion(this.questionnaireService.getStepByID("2"), "2").answer.fields[0].answerValue)
				let tmpSum2 = 0;
				value["incomes"].forEach((element) => {
					tmpSum2 = element.amount + tmpSum2;
				});
				let sum = tmpSum1 - tmpSum2;
				if(sum>0){
					const modalRef = this.modalService.open(FinancingSourcesPopupComponent)
					modalRef.componentInstance.sum = sum;
					modalRef.result.then(
						(res)=>{
						console.log("ok"+res)
					},
						(res)=>{
							console.log("fail"+res)
							let findCurrentIndexQ = this.draft.saveArrDataBasetmp.findIndex(arr => arr.stepName === "popup" && arr.qID === "1");
							if (findCurrentIndexQ !== -1) {
								this.draft.saveArrDataBasetmp.splice(findCurrentIndexQ,1)
							}
							this.draft.saveArrDataBasetmp.push(
							{
							"stepName": "popup",
							"qID": "1",
							"qNames": ["incomeGap"],
							"type": "String",
							"systemTable": "",
							"qNamesSystemTable": "",
							"numberSystemTable": "",
							"answers": [sum]
							})
							this.draft.buildArrDraft(this.submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit)
							this.questionnaireService.sendGA(this.currentStep, this.qID, values);
							this.nextClick(this.submitQID, values);
						}
					);
				}
				else{
					this.draft.buildArrDraft(this.submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit)
					this.questionnaireService.sendGA(this.currentStep, this.qID, values);
					this.nextClick(this.submitQID, values);
				}
			}
			else{
				this.draft.buildArrDraft(this.submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit)
				this.questionnaireService.sendGA(this.currentStep, this.qID, values);
				this.nextClick(this.submitQID, values);
			}
		}
		console.log("Reactive Form submitted: ", this.financingSources)
	}

	private setFinnancingCode(value) {
		if (this.submitQID === "1") {
			for (let i = 0; i < value["incomes"].length; i++) {
				let sourceCode = this.financingSourcesObjects.find(v => v.name === value["incomes"][i].type).code;
				value["incomes"][i].type = sourceCode;
			}
		}
	}

	editQuestionChange(qid) {
		if(this.questionnaireService.isActiveEditQuestion === false){
			this.questionnaireService.isActiveEditQuestion = true;
			this.qID = qid;
			this.setValidators();
		}
	}
	ngAfterViewChecked(): void {
		if (!this._changeDetector['destroyed']) {
			this._changeDetector.detectChanges();
		}
	}

	focusToElement(selector: string) {
		const selectedElement = Array.from(document.querySelectorAll(selector));

		if (selectedElement && selectedElement.length > 0) {
			const nowActiveElement = document.activeElement;
			(nowActiveElement as HTMLElement).blur();
			setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/financing-sources/financing-sources.component.ts